/**
 * Accordion Handlers
 * Generic and specific accordion implementations
 */

// Generic accordion initializer
function initAccordion(config) {
    var container = document.querySelector(config.container);
    if (!container) return;

    var items = container.querySelectorAll(config.itemSelector);
    var headers = container.querySelectorAll(config.headerSelector);

    if (items.length === 0) return;

    // Initialize: Set up initial state
    items.forEach(function(item) {
        var content = item.querySelector(config.contentSelector);
        if (!content) return;

        if (item.classList.contains('active')) {
            content.style.maxHeight = content.scrollHeight + 'px';
        } else {
            content.style.maxHeight = '0';
            content.style.overflow = 'hidden';
        }
    });

    // Add click event listeners
    headers.forEach(function(header) {
        header.addEventListener('click', function(e) {
            e.preventDefault();
            var currentItem = this.closest(config.itemSelector);
            var currentContent = currentItem.querySelector(config.contentSelector);
            if (!currentContent) return;

            var isCurrentlyOpen = currentItem.classList.contains('active');

            if (config.singleOpen && isCurrentlyOpen && !config.allowClose) {
                return;
            }

            if (config.singleOpen && !isCurrentlyOpen) {
                items.forEach(function(item) {
                    var content = item.querySelector(config.contentSelector);
                    if (content) content.style.maxHeight = '0';
                    item.classList.remove('active');
                    if (config.activeClass) item.classList.remove(config.activeClass);
                    if (config.inactiveClass) item.classList.add(config.inactiveClass);
                    if (config.iconSelector) {
                        var icon = item.querySelector(config.iconSelector);
                        if (icon) icon.style.transform = 'rotate(0deg)';
                    }
                    if (config.onClose) config.onClose(item);
                });
            }

            if (isCurrentlyOpen && config.allowClose) {
                currentContent.style.maxHeight = '0';
                currentItem.classList.remove('active');
                if (config.activeClass) currentItem.classList.remove(config.activeClass);
                if (config.inactiveClass) currentItem.classList.add(config.inactiveClass);
                if (config.iconSelector) {
                    var icon = currentItem.querySelector(config.iconSelector);
                    if (icon) icon.style.transform = 'rotate(0deg)';
                }
                if (config.onClose) config.onClose(currentItem);
            } else if (!isCurrentlyOpen) {
                currentItem.classList.add('active');
                if (config.activeClass) currentItem.classList.add(config.activeClass);
                if (config.inactiveClass) currentItem.classList.remove(config.inactiveClass);
                currentContent.style.maxHeight = currentContent.scrollHeight + 'px';
                if (config.iconSelector) {
                    var icon = currentItem.querySelector(config.iconSelector);
                    if (icon) icon.style.transform = 'rotate(180deg)';
                }
                if (config.onOpen) config.onOpen(currentItem);
            }
        });
    });
}

// Accordion configurations
var accordionConfigs = [
    {
        container: '#healthcare-accordion-custom',
        itemSelector: '.accordion-item',
        headerSelector: '.accordion-header',
        contentSelector: '.accordion-content',
        activeClass: 'border-primary',
        inactiveClass: 'border-[#D9D9D9]',
        singleOpen: true,
        allowClose: false
    }
];

// FAQ Accordion
function initFAQAccordion() {
    var faqButtons = document.querySelectorAll('.faq-button');
    if (faqButtons.length === 0) return;

    faqButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            var content = this.nextElementSibling;
            var icon = this.querySelector('.faq-icon');
            var isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

            if (isOpen) {
                content.style.maxHeight = '0';
                if (icon) icon.style.transform = 'rotate(0deg)';
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
                if (icon) icon.style.transform = 'rotate(180deg)';
            }
        });
    });
}

// Tech Stack Accordion
function initTechStackAccordion() {
    var accordionItems = document.querySelectorAll('.tech-accordion-item');
    if (accordionItems.length === 0) return;

    accordionItems.forEach(function(item) {
        var header = item.querySelector('.accordion-header');
        if (!header) return;

        header.addEventListener('click', function(e) {
            e.preventDefault();
            var content = item.querySelector('.accordion-content');
            var iconVertical = header.querySelector('.accordion-icon-vertical');

            if (!content) return;

            if (item.classList.contains('active')) {
                item.classList.remove('active');
                content.style.maxHeight = '0';
                if (iconVertical) iconVertical.style.opacity = '1';
            } else {
                item.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
                if (iconVertical) iconVertical.style.opacity = '0';
            }
        });
    });
}

// Footer Accordion Toggle - Global function
window.toggleAccordion = function(button) {
    var content = button.nextElementSibling;
    var plusIcon = button.querySelector('.plus-icon');
    var minusIcon = button.querySelector('.minus-icon');
    var isOpen = content.classList.contains('max-h-[1000px]');

    document.querySelectorAll('[onclick="toggleAccordion(this)"]').forEach(function(btn) {
        if (btn !== button) {
            var otherContent = btn.nextElementSibling;
            var otherPlusIcon = btn.querySelector('.plus-icon');
            var otherMinusIcon = btn.querySelector('.minus-icon');

            otherContent.style.maxHeight = '0px';
            otherContent.classList.remove('max-h-[1000px]');

            if (otherPlusIcon) {
                otherPlusIcon.classList.remove('opacity-0');
                otherPlusIcon.classList.add('opacity-100');
            }
            if (otherMinusIcon) {
                otherMinusIcon.classList.remove('opacity-100');
                otherMinusIcon.classList.add('opacity-0');
            }
        }
    });

    if (isOpen) {
        content.style.maxHeight = '0px';
        content.classList.remove('max-h-[1000px]');
        if (plusIcon) {
            plusIcon.classList.remove('opacity-0');
            plusIcon.classList.add('opacity-100');
        }
        if (minusIcon) {
            minusIcon.classList.remove('opacity-100');
            minusIcon.classList.add('opacity-0');
        }
    } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.add('max-h-[1000px]');
        if (plusIcon) {
            plusIcon.classList.remove('opacity-100');
            plusIcon.classList.add('opacity-0');
        }
        if (minusIcon) {
            minusIcon.classList.remove('opacity-0');
            minusIcon.classList.add('opacity-100');
        }
    }
};

// AI Services Accordion with Image Switching
function initAIServicesAccordion() {
    var accordionButtons = document.querySelectorAll('.accordion-button');
    var accordionContents = document.querySelectorAll('.accordion-content');
    var images = document.querySelectorAll('.ai-service-image');
    var lastActiveImage = null;

    if (accordionButtons.length === 0) return;

    // Initialize first tab as active
    var firstButton = accordionButtons[0];
    var firstContent = accordionContents[0];
    if (firstButton && firstContent) {
        var firstTabNumber = firstButton.getAttribute('data-tab');
        var firstImages = document.querySelectorAll('.ai-service-image[data-image="' + firstTabNumber + '"]');
        var firstTitle = firstButton.querySelector('span:first-child');
        var firstIcon = firstButton.querySelector('.accordion-icon');

        firstButton.classList.add('active');
        firstContent.classList.add('active');
        firstContent.style.maxHeight = firstContent.scrollHeight + 'px';

        if (firstIcon) {
            firstIcon.textContent = '−';
            firstIcon.classList.remove('text-[#002559]');
            firstIcon.classList.add('text-primary');
        }

        if (firstTitle) {
            firstTitle.classList.remove('text-[#002559]');
            firstTitle.classList.add('text-primary');
        }

        images.forEach(function(img) {
            img.classList.remove('opacity-100');
            img.classList.add('opacity-0', 'pointer-events-none');
        });

        if (firstImages.length > 0) {
            firstImages.forEach(function(img) {
                img.classList.remove('opacity-0', 'pointer-events-none');
                img.classList.add('opacity-100');
            });
            lastActiveImage = firstImages[0];
        }
    }

    accordionButtons.forEach(function(button, index) {
        button.addEventListener('click', function() {
            var tabNumber = this.getAttribute('data-tab');
            var content = this.nextElementSibling;
            var icon = this.querySelector('.accordion-icon');
            var targetImages = document.querySelectorAll('.ai-service-image[data-image="' + tabNumber + '"]');
            var title = this.querySelector('span:first-child');

            accordionButtons.forEach(function(btn, idx) {
                if (btn !== button) {
                    btn.classList.remove('active');
                    var otherContent = accordionContents[idx];
                    if (otherContent) {
                        otherContent.classList.remove('active');
                        otherContent.style.maxHeight = '0';
                    }
                    var otherIcon = btn.querySelector('.accordion-icon');
                    var otherTitle = btn.querySelector('span:first-child');

                    if (otherIcon) {
                        otherIcon.textContent = '+';
                        otherIcon.classList.remove('text-primary');
                        otherIcon.classList.add('text-[#002559]');
                    }
                    if (otherTitle) {
                        otherTitle.classList.remove('text-primary');
                        otherTitle.classList.add('text-[#002559]');
                    }
                }
            });

            if (this.classList.contains('active')) {
                this.classList.remove('active');
                content.classList.remove('active');
                content.style.maxHeight = '0';
                if (icon) {
                    icon.textContent = '+';
                    icon.classList.remove('text-primary');
                    icon.classList.add('text-[#002559]');
                }
                if (title) {
                    title.classList.remove('text-primary');
                    title.classList.add('text-[#002559]');
                }

                var hasActiveTab = Array.from(accordionButtons).some(function(btn) {
                    return btn.classList.contains('active');
                });

                if (!hasActiveTab) {
                    if (targetImages.length > 0) {
                        targetImages.forEach(function(img) {
                            img.classList.remove('opacity-0', 'pointer-events-none');
                            img.classList.add('opacity-100');
                        });
                    } else if (lastActiveImage) {
                        lastActiveImage.classList.remove('opacity-0', 'pointer-events-none');
                        lastActiveImage.classList.add('opacity-100');
                    }
                } else {
                    targetImages.forEach(function(img) {
                        img.classList.remove('opacity-100');
                        img.classList.add('opacity-0', 'pointer-events-none');
                    });
                }
            } else {
                this.classList.add('active');
                content.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
                if (icon) {
                    icon.textContent = '−';
                    icon.classList.remove('text-[#002559]');
                    icon.classList.add('text-primary');
                }
                if (title) {
                    title.classList.remove('text-[#002559]');
                    title.classList.add('text-primary');
                }

                images.forEach(function(img) {
                    img.classList.remove('opacity-100');
                    img.classList.add('opacity-0', 'pointer-events-none');
                });

                if (targetImages.length > 0) {
                    targetImages.forEach(function(img) {
                        img.classList.remove('opacity-0', 'pointer-events-none');
                        img.classList.add('opacity-100');
                    });
                    lastActiveImage = targetImages[0];
                }
            }
        });
    });
}

// Initialize all accordions
export function initAllAccordions() {
    accordionConfigs.forEach(function(config) {
        initAccordion(config);
    });
    initFAQAccordion();
    initTechStackAccordion();
    initAIServicesAccordion();
}

